module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-5-big-776c1aa2fcbe5356d73f80624e7fd8b2.jpg";